import { apiConfig } from '../../config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export function getArfcnValues(deviceId, product) {
  const auth = window.__APP_AUTH;
  const url = apiConfig.cmServiceGetArfcnValues(deviceId, product);

  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth.accessToken,
    'Content-Type': 'application/json'
  };

  return fetchdata(url, { headers, method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
